import React, { useState, type FormEvent } from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
export function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitted(true);
  }
  return <main className="bg-[#f7f4ec] text-[#1d2d2a]" data-id="element-534" data-mp="xrgl5vtyvuho">
      <PageHero eyebrow="Contact our Kathmandu team" title="A clear question is the best place to start." description="Tell us where you are in the planning process. We will reply with practical advice, not a hard sell." image="https://images.unsplash.com/photo-1605649487212-47bdab064df7?auto=format&fit=crop&w=1800&q=85" data-id="element-535" data-mp="zv8gq1sgtbh" />
      <section className="mx-auto grid max-w-6xl gap-12 px-5 py-20 sm:px-8 sm:py-28 lg:grid-cols-[0.8fr_1.2fr] lg:px-10" data-id="element-536" data-mp="1lex4wa362gx0">
        <aside data-id="element-537" data-mp="1qdi4q8eiaykx">
          <p className="eyebrow" data-id="element-538" data-mp="1qcynyv0leg8h">Reach us directly</p>
          <h2 className="mt-4 font-display text-4xl" data-id="element-539" data-mp="1qfumolk9l8xz">
            Here when you are ready.
          </h2>
          <dl className="mt-8 space-y-6 text-sm leading-7 text-[#55615a]" data-id="element-540" data-mp="mz3cblnwrsy6">
            <div className="flex gap-4" data-id="element-541" data-mp="mwz08gfuvnmt">
              <MapPinIcon className="shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-542" data-mp="hzgz3c82ycpd" />
              <div data-id="element-543" data-mp="d04424721zbp">
                <dt className="font-bold text-[#1d2d2a]" data-id="element-544" data-mp="d0nnxqg9mxsd">Kathmandu office</dt>
                <dd data-id="element-545" data-mp="82m24xrggkd7">Thamel, Kathmandu, Nepal</dd>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-546" data-mp="3a1cm8fl0tfh">
              <MailIcon className="shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-547" data-mp="38zph5lakghe" />
              <div data-id="element-548" data-mp="3qg21292ao5iz">
                <dt className="font-bold text-[#1d2d2a]" data-id="element-549" data-mp="3qgla109yvjkv">Email</dt>
                <dd data-id="element-550" data-mp="3lgpfdrn5t4hz">hello@manaslutrekking.com</dd>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-551" data-mp="3litkgcwso9ju">
              <PhoneIcon className="shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-552" data-mp="3ghch8aqu8b03" />
              <div data-id="element-553" data-mp="36sfbl8gsju0j">
                <dt className="font-bold text-[#1d2d2a]" data-id="element-554" data-mp="36w35w9u28kgb">Phone</dt>
                <dd data-id="element-555" data-mp="3btwbb0njhafj">+977 1 555 0182</dd>
              </div>
            </div>
          </dl>
        </aside>
        <form onSubmit={handleSubmit} className="bg-[#e9e3d5] p-6 sm:p-8" aria-label="Contact form" data-id="element-556" data-mp="2xun4grl83so8">
          {submitted ? <div role="status" className="py-12 text-center" data-id="element-557" data-mp="3pjzt9ffdyhz6">
              <p className="eyebrow" data-id="element-558" data-mp="3pmubd0axfqpf">Message received</p>
              <h2 className="mt-4 font-display text-3xl" data-id="element-559" data-mp="3uijhjmhgc5up">
                Thank you for reaching out.
              </h2>
              <p className="mx-auto mt-4 max-w-md text-sm leading-7 text-[#55615a]" data-id="element-560" data-mp="3grxt7i98b3pf">
                Our team will be in touch with practical next steps shortly.
              </p>
            </div> : <>
              <h2 className="font-display text-3xl" data-id="element-561" data-mp="h4oeudueeexy">Send an inquiry</h2>
              <div className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-562" data-mp="h5zk6i3hrur6">
                <label className="text-sm font-bold" data-id="element-563" data-mp="21ubspkwxrng7">
                  Full name
                  <input required name="name" className="mt-2 w-full border border-[#bcb3a1] bg-[#f7f4ec] px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-564" data-mp="1wwjy2j4wpn8b" />
                </label>
                <label className="text-sm font-bold" data-id="element-565" data-mp="26o66k7pv187d">
                  Email address
                  <input required type="email" name="email" className="mt-2 w-full border border-[#bcb3a1] bg-[#f7f4ec] px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-566" data-mp="1iybu3r9gdlnn" />
                </label>
              </div>
              <label className="mt-5 block text-sm font-bold" data-id="element-567" data-mp="349kc72tg5fc5">
                What would you like to know?
                <textarea required name="message" rows={6} className="mt-2 w-full resize-y border border-[#bcb3a1] bg-[#f7f4ec] px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-568" data-mp="2zar82101v0on" />
              </label>
              <button type="submit" className="mt-6 bg-[#A48C5A] px-6 py-4 text-sm font-bold text-[#172a27] transition-colors hover:bg-[#D9CAA0]" data-id="element-569" data-mp="1hubpu2jl3y64">
                Send inquiry
              </button>
            </>}
        </form>
      </section>
    </main>;
}